module.exports = __webpack_public_path__ + "img/get_the_app_header.339ec75e.svg";